
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests/duke-rector-two-dragons",
      function () {
        return require("private-next-pages/contests/duke-rector-two-dragons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests/duke-rector-two-dragons"])
      });
    }
  